import Cookies, { CookieAttributes } from 'js-cookie'

export enum CookieKeyTypeEnum {
  cep = 'cep',
  campaign = 'campaign',
  isPickUpChoose = 'isPickUpChoose',
}

const baseKey = process.env.REACT_APP_STORAGE_KEY

export const getCookieDomain = () => {
  return window.location.hostname.includes('localhost')
    ? 'localhost'
    : '.gazin.com.br'
}

export const getCookieKey = (key: CookieKeyTypeEnum) => `${baseKey}${key}`

export const getCookieItem = (key: CookieKeyTypeEnum) => {
  return Cookies.get(getCookieKey(key)) ?? undefined
}

export const setCookieItem = (
  key: CookieKeyTypeEnum,
  value: string,
  options: Omit<CookieAttributes, 'domain'> = {}
) => {
  Cookies.set(getCookieKey(key), value, {
    ...options,
    ...{ domain: getCookieDomain() },
  })
}

export const removeCookieItem = (key: CookieKeyTypeEnum) => {
  Cookies.remove(getCookieKey(key), { domain: getCookieDomain() })
}

export const parseServerSideRawCookies = (rawCookies: string) => {
  if (rawCookies === '') return {}

  const pairs = rawCookies.split(';')
  const splittedPairs = pairs.map((cookie) => cookie.split('='))

  return splittedPairs.reduce(function (obj, cookie) {
    const cookieKey = cookie?.[0]
      ? decodeURIComponent(cookie?.[0]?.trim())
      : null
    const cookieValue = cookie?.[1]
      ? decodeURIComponent(cookie?.[1]?.trim())
      : undefined

    if (!cookieKey || !cookieValue) return obj

    obj[cookieKey] = cookieValue

    return obj
  }, {})
}
